import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, X, Loader2 } from "lucide-react";
import { communityUpload } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const abs = (url) => (url?.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`);

export default function AttachImages({ images, setImages, max = 6 }) {
  const { pick } = useLang();
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    if (images.length + files.length > max) {
      toast(pick("बहुत अधिक चित्र", "Too many images"), { description: pick(`अधिकतम ${max}`, `Max ${max} images.`) });
      return;
    }
    setBusy(true);
    try {
      for (const f of files) {
        const r = await communityUpload(f);
        setImages((prev) => [...prev, abs(r.url)]);
      }
    } catch (err) {
      toast(pick("अपलोड विफल", "Upload failed"), { description: err?.response?.data?.detail || pick("पुनः प्रयास करें।", "Please try again.") });
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {images.length > 0 && (
        <div className="mb-2 flex flex-wrap gap-2">
          {images.map((src, i) => (
            <div key={i} className="relative h-16 w-16 overflow-hidden rounded border border-line">
              <img src={src} alt="" className="h-full w-full object-cover" />
              <button type="button" onClick={() => setImages(images.filter((_, j) => j !== i))}
                data-testid={`attach-remove-${i}`}
                className="absolute right-0 top-0 bg-ink/70 p-0.5 text-white"><X className="h-3 w-3" /></button>
            </div>
          ))}
        </div>
      )}
      <input ref={inputRef} type="file" accept="image/*" multiple onChange={onPick} className="hidden" data-testid="attach-file-input" />
      <button type="button" onClick={() => inputRef.current?.click()} disabled={busy || images.length >= max}
        data-testid="attach-image-button"
        className="inline-flex items-center gap-1.5 border border-line px-3 py-1.5 text-xs text-ink-2 transition-colors hover:border-saffron hover:text-saffron disabled:opacity-50">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ImagePlus className="h-3.5 w-3.5" />}
        {pick("चित्र जोड़ें", "Add image")}
      </button>
    </div>
  );
}
